import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import BreadCrumbsPage from 'components/Breadcrumb/Breadcrumb';
import useI18n from 'hooks/use-i18n';
// import DashboardInstructor from 'modules/Home/Instructor';
import HomeLearner from 'modules/Home/Learner';
import DashboardAdmin from 'modules/Home/Admin/newAdminDashboard';
import OnboardDashboard from 'modules/Home/Onboard';
import DashboardInstructor from 'modules/Home/Instructor/newInstructorDashboard';
import { getViewMode } from 'store/auth';
import { getDashboardType } from 'store/global';
import { USER_ROLES } from '../constants/constants';
import { handleToastError } from 'helpers';
import reportApi from 'api/reportApi';
import CentreAdmin from 'modules/Home/CentreAdmin';
import { useRouter } from 'next/router';
import { useUser } from 'hooks';

const Dashboard = () => {
  const i18n = useI18n();
  const viewMode = useSelector(getViewMode);
  const dashboardType = useSelector(getDashboardType);
  const router = useRouter();
  const user = useUser();

  const breadcrumb = [
    {
      text: i18n.t('dashboard'),
      active: true,
    },
  ];

  // const JoinedCount = async () => {
  //   try {
  //     const response = await reportApi.getJoinedCount();
  //     localStorage.setItem('livereportcount', JSON.stringify(response));
  //   } catch (e) {
  //     handleToastError(e);
  //   }
  // };

  useEffect(() => {
    let array = [
      {
        text: 'Dashboard',
        link: '/',
        customLink: '/',
        val: 'dashboard',
      },
    ];
    sessionStorage.setItem('breadCrumb', JSON.stringify(array));
    // (viewMode === USER_ROLES.ADMIN || viewMode === USER_ROLES.SUPER_ADMIN) &&
    //   JoinedCount();
  }, []);

  const shouldShowOnboarding =
    dashboardType === 'onboarding' ||
    user?.type.name === 'HR' ||
    user?.type.name === 'FINANCE';

  return (
    <>
      {/* <BreadCrumbsPage data={breadcrumb} /> */}

      {viewMode === USER_ROLES.INSTRUCTOR && <DashboardInstructor />}
      {viewMode === USER_ROLES.ADMIN &&
        (shouldShowOnboarding ? <OnboardDashboard /> : <DashboardAdmin />)}

      {viewMode === USER_ROLES.CENTRE_ADMIN && <CentreAdmin />}
      {viewMode === USER_ROLES.LEARNER && <HomeLearner />}

      {viewMode === USER_ROLES.CENTRE_BL &&
        (dashboardType === 'onboarding' ? (
          <OnboardDashboard />
        ) : (
          <DashboardAdmin />
        ))}
    </>
  );
};
export default Dashboard;
